import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=07d23c60&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports